import { render } from "./EventReport.vue?vue&type=template&id=588e08ea&scoped=true"
import script from "./EventReport.vue?vue&type=script&lang=js"
export * from "./EventReport.vue?vue&type=script&lang=js"

import "./EventReport.vue?vue&type=style&index=0&id=588e08ea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588e08ea"]])

export default __exports__